var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bc-status"},[(_vm.tender.failed_bc_details)?_c('em',{staticClass:"icon-exclamation status",attrs:{"title":_vm.$t('tenders.bc_synced_status.error')}}):_c('em',{staticClass:"icon-check",attrs:{"title":_vm.$t('tenders.bc_synced_status.synced')}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb071a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BCTenderStatus.vue
// module id = null
// module chunks = 